<template>
  <div
    :class="withIcon ? 'col-12 col-sm-4' : 'col-xs-12 col-sm-6 col-lg-3'"
  >
    <div class="form-group">
      <div class="custom-dropdown">
        <!-- aria-haspopup="true"
        data-toggle-second="tooltip" -->
        <button
          class="form-control dropdown-toggle text-left sector"
          type="button"
          id="sector"
          data-toggle="dropdown"
          aria-expanded="false"
          data-placement="top"
          data-html="true"
          title="Please choose the sectors you’re interested in: <br><br> <b>Sector 1 -</b> Lorem ipsum lorem ipsum lorem ipsum <br> <b>Sector 2 -</b> Lorem ipsum lorem ipsum lorem ipsum <br><b>Sector 3 -</b> Lorem ipsum lorem ipsum lorem ipsum"
        >
          <slot></slot>
          Sector
          <i class="icon icon-arrow-down-custom icon-right"></i>
        </button>
        <div class="dropdown-menu" aria-labelledby="sector">
          <ul>
            <li v-for="sector in sectors">
              <span class="custom-control custom-checkbox rtl">
                <input
                  type="checkbox"
                  name="sector[]"
                  class="custom-control-input"
                  :id="sector.name"
                  :checked="selected(sector)"
                  v-on:click="toggleSearch(sector)"
                >
                  <label class="custom-control-label" :for="sector.name">
                    {{ sector.name }}
                    <sup class="text-primary lead help">
                      <!-- <strong
                        data-placement="top"
                        data-toggle="tooltip"
                        title="Nulla non ipsum in enim condimentum viverra nec ac sem. Suspendisse convallis molestie nulla in consectetur. In porttitor risus id risus congue, nec accumsan urna pharetra.">
                        ?
                      </strong> -->
                    </sup>
                  </label>
                </input>
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
  name: "sector-dropdown",
  props: ['withIcon', 'type'],
  computed: {
    ...mapGetters({
      results: "results",
      sectors: "sectors",
      capitalTypeSelected: 'capitalTypeSelected',
      providerTypeSelected: 'providerTypeSelected',
      countrySelected: 'countrySelected',
      sectorSelected: 'sectorSelected',
      dataSectorSelected: 'dataSectorSelected'
    })
  },
  methods: {
    ...mapMutations([
      'toggleSectorsParam',
      'toggleCapitalTypesParam',
      'toggleProviderTypesParam',
      'toggleCountriesParam',
      'setSelectedDataSectors'
    ]),
    selected: function(value){
      if (this.type=='chart') {
        return this.dataSectorSelected(value)
      } else {
        return this.sectorSelected(value)
      }
    },
    ...mapActions(['search']),
    toggleSearch(value){
      if (this.type == 'chart') {
        this.setSelectedDataSectors(value)
      } else {
        this.toggleSectorsParam(value)
      }
      this.$emit('user-select')
      $('.dropdown-menu').click(function(e) {
        e.stopPropagation();
      });
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/elements/SearchBars/dropdowns/SectorDropDown.vue